import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
export class ProductSettingsResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.useRoboticFollowUp = false;
        this.useEstablishmentFeeFinancingOption = false;
        this.useProductInformationMultipleDocuments = false;
        this.showValidLimitTypeSelection = false;
        this.showLimitProductSelection = false;
        this.activeLimitTypes = [""];
        this.useDefaultPhoenixDropdownProductSelectorMenu = true;
    }
    pk() {
        return "ProductSettingsResourceSingleton";
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            invalidIfStale: true,
            dataExpiryLength: Infinity
        };
    }
    static url(urlParams) {
        return this.listUrl(urlParams);
    }
    static async fetch(input, init) {
        return await super.fetch(input, init);
    }
}
ProductSettingsResource.urlRoot = apiResourceUrl("products/productSettings");
//# sourceMappingURL=ProductSettingsResource.js.map